import Household from '@advisor/models/store/household/index';
import HouseholdService from '@advisor/services/household';
import {returnNoneApi} from '@advisor/util/returnNoneApi';
import exceptionHandler from '@advisor/util/exceptionHandler';

const stateObj = function () {
  return new Household();
};

const actions = {
  /**
   * This will fetch target HouseHold Information for top bar
   * @param {Object} param0
   * @param {Object} payload Should contain householdId
   *
   * '@returns {Promise}
   */
  async getHouseHoldInfo({commit}, payload) {
    try {
      const apiCall = await HouseholdService.getHouseHoldInfo(payload);

      returnNoneApi(apiCall);
      commit('SET_HOUSEHOLD_INFO', apiCall.data);

      return apiCall.data;
    } catch (error) {
      exceptionHandler.handleGenericException('household.getHouseHoldInfo', error);

      return Promise.reject(error);
    }
  },
  /**
   * This will fetch household goals as well as Client goals and related account information
   * @param {Object} param0
   * @param {Object} payload Should contain householdId
   *
   * @returns {Promise}
   */
  async getSummaryGoalList({commit}, payload) {
    try {
      const apiCall = await HouseholdService.getSummaryGoalList(payload);

      returnNoneApi(apiCall);
      commit('SET_SUMMARY_GOALS', apiCall.data);

      return apiCall.data;
    } catch (error) {
      exceptionHandler.handleGenericException('household.getSummaryGoalList', error);

      return Promise.reject(error);
    }
  },
  /**
   * This will fetch household Member's accounts as well as its goals
   * @param {Object} param0
   * @param {Object} payload Should contain clientId
   *
   * @returns {Promise}
   */
  async getClientWithSubResources({commit}, payload) {
    try {
      const apiCall = await HouseholdService.getClientWithSubResources(payload);

      returnNoneApi(apiCall);

      commit('SET_CLIENT_DETAILS', apiCall.data.data);

      return apiCall.data.data;
    } catch (error) {
      exceptionHandler.handleGenericException('household.getClientWithSubResources', error);

      return Promise.reject(error);
    }
  },
  /**
   * This will attach account to Goal
   * @param {Object} payload Should contain goalId, AccountId
   *
   * @returns {Promise}
   */
  async assignGoalToAccount(payload) {
    try {
      const apiCall = await HouseholdService.assignGoalToAccount(payload);

      returnNoneApi(apiCall);

      return apiCall.data.data;
    } catch (error) {
      exceptionHandler.handleGenericException('household.assignGoalToAccount', error);

      return Promise.reject(error);
    }
  },
  /**
   * This will remove client from Household, related accounts are also unattached from household.
   * @param {Object} param0
   * @param {Object} payload Should contain clientId
   *
   * @returns {Promise}
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async deleteClient({commit}, payload) {
    try {
      const apiCall = await HouseholdService.deleteClient(payload);

      returnNoneApi(apiCall);

      return apiCall.data;
    } catch (error) {
      exceptionHandler.handleGenericException('household.deleteClient', error);

      return Promise.reject(error);
    }
  },
  /**
   * This will add household Goal.
   * @param {Object} payload Should contain Goal
   *
   * @returns {Promise}
   */
  async addHouseholdGoal({commit}, payload) {
    try {
      const apiCall = await HouseholdService.addHouseholdGoal(payload);

      commit('SET_HH_ACCOUNTS', apiCall.data.data);
      returnNoneApi(apiCall);

      return apiCall.data;
    } catch (error) {
      exceptionHandler.handleGenericException('household.addHouseholdGoal', error);

      return Promise.reject(error);
    }
  },
  /**
   * This will update household Goal.
   * @param {Object} payload Should contain HouseholdGoalId
   *
   * @returns {Promise}
   */
  async updateHouseholdGoal({commit}, payload) {
    try {
      const apiCall = await HouseholdService.updateHouseholdGoal(payload);

      commit('SET_HH_ACCOUNTS', apiCall.data.data);
      returnNoneApi(apiCall);

      return apiCall.data;
    } catch (error) {
      exceptionHandler.handleGenericException('household.updateHouseholdGoal', error);

      return Promise.reject(error);
    }
  },

  /** This will fetch accounts that are associated with household.
   * @param {Object} param0
   * @param {Object} payload Should contain HHId
   *
   * @returns {Promise}
   */
  async fetchHouseholdAccounts({commit}, payload) {
    try {
      const apiCall = await HouseholdService.fetchHHAccounts(payload);

      commit('SET_HH_ACCOUNTS', apiCall.data.data);

      return apiCall.data;
    } catch (error) {
      exceptionHandler.handleGenericException('household.fetchHouseholdAccounts', error);

      return Promise.reject(error);
    }
  },
  /** This will remove household,also remove all goals and accounts attached to that household
   * @param {Object} param0
   * @param {Object} payload Should contain HouseholdId
   *
   * @returns {Promise}
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async deleteHousehold({commit}, payload) {
    try {
      const apiCall = await HouseholdService.deleteHousehold(payload);

      returnNoneApi(apiCall);

      return apiCall.data;
    } catch (error) {
      exceptionHandler.handleGenericException('household.deleteHousehold', error);

      return Promise.reject(error);
    }
  },
  /**
   * This will fetch unassigned accounts of all members of household
   * @param {Object} param0
   * @param {Object} payload Should contain householdId
   *
   * @returns {Promise}
   */
  async getUnassignedAccounts({commit}, payload) {
    try {
      const apiCall = await HouseholdService.getUnassignedAccounts(payload);

      returnNoneApi(apiCall);
      commit('SET_UNASSIGNED_ACCOUNTS', apiCall.data);

      return apiCall.data;
    } catch (error) {
      exceptionHandler.handleGenericException('household.getUnassignedAccounts', error);

      return Promise.reject(error);
    }
  },
  /**
   *  This will fetch household goals of household, it will be dsiplayed in dropdown for unassigned accounts.
   * @param {Object} param0
   * @param {Object} payload Should contain householdId
   *
   * @returns {Promise}
   */
  async getHouseholdGoals({commit}, payload) {
    try {
      const apiCall = await HouseholdService.getHouseholdGoals(payload);

      returnNoneApi(apiCall);
      commit('SET_HH_GOALS', apiCall.data);

      return apiCall.data;
    } catch (error) {
      exceptionHandler.handleGenericException('household.getHouseholdGoals', error);

      return Promise.reject(error);
    }
  },
  /**
   *  This will fetch client account list to display it on add/edit hh model.
   * @param {Object} param0
   *
   * @returns {Promise}
   */
  async fetchHHClientAccounts({commit}, payload) {
    try {
      const apiCall = await HouseholdService.getClientAccounts(payload);

      returnNoneApi(apiCall);
      commit('SET_CL_ACCOUNTS', apiCall.data);

      return apiCall.data;
    } catch (error) {
      exceptionHandler.handleGenericException('household.fetchHHClientAccounts', error);

      return Promise.reject(error);
    }
  },
  /**
   *  This will create a new household and assign client and accounts and respective lient goals.
   * @param {Object} param0
   *
   * @returns {Promise}
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async addHousehold({commit}, payload) {
    try {
      const apiCall = await HouseholdService.addHousehold(payload);

      return apiCall.data;
    } catch (error) {
      exceptionHandler.handleGenericException('household.addHousehold', error);

      return Promise.reject(error);
    }
  },
  /**
   *  This will update household info and assign client and accounts and respective lient goals.
   * @param {Object} param0
   *
   * @returns {Promise}
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async updateHousehold({commit}, payload) {
    try {
      const apiCall = await HouseholdService.updateHousehold(payload);

      returnNoneApi(apiCall);

      return apiCall.data;
    } catch (error) {
      exceptionHandler.handleGenericException('household.updateHousehold', error);

      return Promise.reject(error);
    }
  },
  async getHouseholdGoalAccounts({commit}, params) {
    try {
      const apiCall = await HouseholdService.getHouseholdGoalAccounts(params);

      commit('SET_HH_GOAL_ACCOUNTS', apiCall.data);
      returnNoneApi(apiCall);

      return apiCall.data;
    } catch (error) {
      exceptionHandler.handleGenericException('household.getHouseholdGoalAccounts', error);

      return Promise.reject(error);
    }
  },
  async getHouseholdGoalDetail({commit}, params) {
    try {
      const apiCall = await HouseholdService.getHouseholdGoalDetail(params);

      commit('SET_HH_GOAL_SUMMARY', apiCall.data);
      returnNoneApi(apiCall);

      return apiCall.data;
    } catch (error) {
      exceptionHandler.handleGenericException('household.getHouseholdGoalDetail', error);

      return Promise.reject(error);
    }
  },
  setAssignDataError({commit}, payload) {
    commit('SET_ASSIGN_DATA_ERROR', payload);
  },
  setAssignedAccounts({commit}, payload) {
    commit('SET_ASSIGNED_ACCOUNTS', payload);
    commit('SET_ASSIGN_DATA_ERROR', false);
  },
  setExcludedClientsAndAccounts({commit}, payload) {
    commit('SET_EXCLUDED_CLIENTS_DATA', payload);
    commit('SET_EXCLUDED_ACCOUNTS_DATA', payload);
  },
  reSetExcludedClientAccountToStore({commit}, payload) {
    commit('RESET_EXCLUDED_CLIENTS_DATA', payload);
    commit('RESET_EXCLUDED_ACCOUNTS_DATA', payload);
  },
  resetAssignedListData({commit}, payload) {
    commit('RESET_ASSIGNED_DATA', payload);
  },
  setAccountCount({commit}, payload) {
    commit('SET_ACCOUNT_COUNT', payload);
  },
  setDefaultState({commit}) {
    commit('SET_DEFAULT_CL_ACCOUNTS');
    commit('SET_DEFAUT_STATE_ASSIGNED_DATA');
  },
};

const mutations = {
  SET_DEFAULT_CL_ACCOUNTS(state) {
    state.excludedAccounts = [];
    state.excludedClients = [];
  },
  SET_HOUSEHOLD_INFO(state, payload) {
    state.selectedHousehold = payload.data;
  },
  SET_SUMMARY_GOALS(state, payload) {
    state.summaryGoals = payload.data;
  },
  SET_CLIENT_DETAILS(state, payload) {
    state.clients = [];
    state.clients.push(payload);
  },
  SET_HH_ACCOUNTS(state, payload) {
    state.hhAccounts = payload.data;
  },
  SET_HH_GOALS(state, payload) {
    state.householdGoals = payload.data;
  },
  SET_HH_GOAL_ACCOUNTS(state, payload) {
    state.householdGoalAccounts = payload.data.accounts;
  },

  SET_UNASSIGNED_ACCOUNTS(state, payload) {
    state.unassignedAccounts = payload.data;
  },
  SET_CL_ACCOUNTS(state, payload) {
    state.clientAccounts = payload;
  },
  SET_EXCLUDED_CLIENTS_DATA(state, payload) {
    state.excludedClients = [...state.excludedClients, ...payload.clients];
  },

  SET_ASSIGNED_ACCOUNTS(state, payload) {
    if (state.assignedClAccounts.length > 0) {
      const oldData = state.assignedClAccounts;

      oldData.forEach((client) => {
        const index = _.findIndex(payload, {id: client.id});

        if (index !== -1) {
          const payloadArry = payload[index];

          if (payloadArry.accountDetail.length > 0) {
            // eslint-disable-next-line no-param-reassign
            client.accounts += payloadArry.accountDetail.length;
            payloadArry.accountDetail.forEach((account) => {
              client.accountDetail.push(account);
            });
          }

          payload.splice(index, 1);
        }
      });

      if (payload.length > 0) {
        payload.forEach((clientData) => {
          oldData.push(clientData);
        });
      }

      state.assignedClAccounts = oldData;

      return;
    }

    state.assignedClAccounts = payload;
  },
  SET_DEFAUT_STATE_ASSIGNED_DATA(state) {
    state.assignedClAccounts = [];
  },
  SET_EXCLUDED_ACCOUNTS_DATA(state, payload) {
    if (payload.accounts.length > 0) {
      state.excludedAccounts = [...state.excludedAccounts, ...payload.accounts];
    }
  },
  RESET_EXCLUDED_CLIENTS_DATA(state, payload) {
    if (payload.clients.length > 0) {
      const {clients} = payload;

      state.excludedClients = state.excludedClients.filter((item) => !clients.includes(item));
    }
  },
  RESET_EXCLUDED_ACCOUNTS_DATA(state, payload) {
    if (payload.accounts.length > 0) {
      state.excludedAccounts = state.excludedAccounts.filter((item) => !payload.accounts.includes(item));
    }
  },
  RESET_ASSIGNED_DATA(state, payload) {
    const {assignedClAccounts} = state;

    if (payload.length > 0) {
      payload.forEach((client) => {
        const index = _.findIndex(assignedClAccounts, {id: client.id});

        if (client.selected) assignedClAccounts.splice(index, 1);

        if (client.intermediate) {
          assignedClAccounts[index].clientAssigned = false;
          assignedClAccounts[index].intermediate = false;
          client.accountDetail.forEach((account) => {
            const accountIndex = _.findIndex(assignedClAccounts[index].accountDetail, {id: account.id});

            assignedClAccounts[index].accountDetail.splice(accountIndex, 1);
          });
          assignedClAccounts[index].accounts = assignedClAccounts[index].accountDetail.length;
          assignedClAccounts[index].accountDetail.forEach((acc) => {
            state.excludedAccounts.push(acc.id);
          });
        }
      });
    }
  },
  SET_ACCOUNT_COUNT(state, payload) {
    state.selectedAccountCount = payload || payload.count;
  },
  SET_ASSIGN_DATA_ERROR(state, payload) {
    state.assignDataError = payload;
  },
  SET_HH_GOAL_SUMMARY(state, payload) {
    state.householdGoalSummary = payload.data;
  },
};

export default {
  namespaced: true,
  state: stateObj,
  actions,
  mutations,
};
